import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.div`
  position: absolute;
  top: calc(251px - 6px);
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 8px;

  @media screen and (min-width: ${DESKTOP}px) {
    top: 0;
    right: calc(50% - 10px);
    height: 100%;
    width: auto;
    flex-direction: column;
    gap: 12px;
  }
`;
